import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import WatchListButton from '../../../WatchlistButton';
import Controls from '../../Controls';

import { StyledWrapper, StyledControls } from './Styles';
import { FilterNames } from '../../../../_shared/types/trade';
import useWatchlist from '../../../../_shared/hooks/useWatchlist';
import { BidSource } from '../../../../_shared/types/auction';
import DealerInfo from '../Content/DealerInfo';

// TODO: Update this once finalized
const propTypes = {
  tradeSummary: PropTypes.shape({
    id: PropTypes.number,
    auctionSummary: PropTypes.shape({
      maxBid: PropTypes.number,
      numBids: PropTypes.number
    }),
    isWatchlisted: PropTypes.bool
  }).isRequired
};

const Footer = ({
  bidModalRef,
  tradeSummary: {
    auctionSummary,
    dealer,
    id: tradeId,
    isAsIs,
    isWatchlisted,
    isImpounded,
    network,
    tradeVehicleSummary: { vehicleSummary },
    vin
  },
  variant,
  setShouldShowTrade
}) => {
  const [tradeState, activeFilter] = useSelector(
    state => [state?.ui?.nav?.secondary?.context, state?.filter?.activeFilter],
    shallowEqual
  );
  const { setBidContext } = bidModalRef?.current ?? {};

  const [watchList, setWatchList] = useWatchlist(
    tradeId,
    tradeState,
    isWatchlisted
  );

  return (
    <StyledWrapper>
      <DealerInfo dealer={dealer} network={network} variant={variant} />
      <StyledControls variant={variant}>
        {!(activeFilter?.id === FilterNames.impound.id || isImpounded) && (
          <WatchListButton
            auctionId={auctionSummary?.id}
            isAsIs={isAsIs}
            isWatchlisted={watchList}
            modelName={vehicleSummary?.model?.displayName}
            pageSource={BidSource.LIST_VIEW}
            tradeId={tradeId}
            tradeState={tradeState}
            trim={vehicleSummary?.trim}
            variant="fullsize_reverse"
            vin={vin}
            year={vehicleSummary?.modelYear}
            setParentWatchList={setWatchList}
          />
        )}
        <Controls
          auctionSummary={auctionSummary}
          setBidContext={setBidContext}
          setShouldShowTrade={setShouldShowTrade}
          tradeId={tradeId}
          watchList={watchList}
          variant={variant}
          vin={vin}
        />
      </StyledControls>
    </StyledWrapper>
  );
};

Footer.propTypes = propTypes;

export default Footer;
